import React, { Component } from "react";

import { connect } from "react-redux";
import { autobind } from "core-decorators";
import Promise from "bluebird";
import moment from "moment";

import styles from "./User.styles";
import messages from "./User.messages";

import { setActiveProject } from "../../redux/projects/actions";
import { addInvitedProjects } from "../../redux/collaborators/actions";
import { getUser } from "../../redux/user";
import { getActiveProject } from "../../redux/projects";

import { Button, Card, CardBody, CardImg, Table } from "reactstrap";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Navigation from "./components/navigation/Navigation";
import Projects from "./projects/Projects";
import Agenda from "./agenda/Agenda";
import TimelineView from "./timeline/TimelineView";
import TaskListView from "./tasklist/TaskListView";
import ProjectNav from "../../components/project-nav/ProjectNav";
import {
  Route,
  Link,
  Redirect,
  BrowserRouter as Router,
  withRouter,
  Switch,
} from "react-router-dom";

import type { State as AppState, Dispatch } from "../../redux/types";
import type User from "../../models/User";

import Profile from "./profile/Profile";
import Subscription from "./subscription/Subscription";
import Footer from "../../components/Footer";
import { getOneSignalInfo, isMobile } from "../../helpers/Utils";

type OwnProps = {
  onRequestLogout: () => Promise<void>,
  isLoggedIn: boolean,
  redirectToLogin: () => void,
  redirectToProjects: () => void,
  redirectToAgenda: () => void,
  redirectToTimeLine: () => void,
  redirectToTaskList: () => void,
  path: String,
  projectId: String,
};

type StateProps = {
  activeProject: ?Project,
};

type DispatchProps = {};

type Props = OwnProps & StateProps & DispatchProps;

type State = {
  email: string,
  password: string,
};

class UserView extends Component {
  props: Props;

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.addInvitedProjects();
    } else {
      this.props.redirectToLogin();
    }
  }

  componentDidUpdate() {
    {
      this.renderScreen();
    }
  }

  componentWillUnmount() {}

  handleLogout = (event) => {
    event && event.preventDefault();
    this.logoutPromise = Promise.resolve(this.doLogout());
  };

  async doLogout() {
    await this.props.onRequestLogout();
  }

  onProjectDelete() {
    this.props.redirectToProjects();
  }

  handleSelectProject = (project: Project) => {
    this.setActiveProjectPromise = Promise.resolve(this.selectProject(project));
  };

  async selectProject(project: Project) {
    await this.props.setActiveProject(project);
    this.props.onPressProject();
  }

  render() {
    document.body.classList.remove("guest-bg");
    if (this.props.user == null) {
      return <div></div>;
    }
    return (
      <div className="app-main-content-wrapper uppercase-children">
        {this.renderNavbar()}
        <div className="app-main-content">
          <div className={`app-wrapper ${isMobile() ? "mobile-nav" : ""}`}>
            {this.renderScreen()}
          </div>
        </div>
      </div>
    );
  }

  renderRedesignedBanner() {
    return (
      <div
        className="deuppercase-children"
        style={{
          width: "100%",
          height: 40,
          background: "#ebe5e5",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        We've redesigned! We hope you love Loope's whole new look!
      </div>
    );
  }

  renderTimezoneMismatchedBanner() {
    if (this.props.user && this.props.user.timezone !== moment.tz.guess())
      return (
        <div
          className="deuppercase-children"
          style={{
            width: "100%",
            height: 40,
            background: "#ffc75f",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 8px",
          }}
        >
          Timezone mismatch detected! This will screw up notifications. Go to
          your profile settings to resolve this issue.
        </div>
      );
  }

  renderScreen = () => {
    //FIXME hacky, but rendering projects view if there is no active project will
    // have to suffice now that we're aren't redirecting to the login page
    // whenever the app reloads.
    //FIXME It would be nice if we could use the routes as
    // they were meant to be used instead of this nasty method here.
    if (
      this.props.path == "/projects" ||
      (this.props.path.includes("projects") && !this.props.activeProject)
    ) {
      return <div>{this.projectsView()}</div>;
    }
    if (this.props.path.includes("agenda")) {
      return (
        <div>
          {this.props.activeProject ? this.agendaScreen() : this.projectsView()}
        </div>
      );
    }
    if (this.props.path.includes("timeline")) {
      return <div>{this.timelineScreen()}</div>;
    }
    if (this.props.path.includes("tasklist")) {
      return <div>{this.taskListScreen()}</div>;
    }

    if (this.props.path.includes("profile")) {
      return <div>{this.profileScreen()}</div>;
    }
    if (this.props.path.includes("subscription")) {
      if (isMobile()) {
        this.props.redirectToProjects();
      }
      return <div>{this.subscriptionScreen()}</div>;
    }
  };

  renderNavbar() {
    return (
      <div>
        {this.renderRedesignedBanner()}
        {this.renderTimezoneMismatchedBanner()}
        <Navigation
          handleLogout={this.props.onRequestLogout}
          user={this.props.user}
          shouldShowAddProjectButton={
            this.props.path.includes("projects") && !this.props.activeProject
          }
        />
      </div>
    );
  }

  renderProjectNav(activeKey) {
    const project = this.props.activeProject;

    return (
      <ProjectNav
        onRequestShowAgenda={() => this.props.redirectToAgenda(project.id)}
        onRequestShowTaskList={() => this.props.redirectToTaskList(project.id)}
        onRequestShowTimeline={() => this.props.redirectToTimeLine(project.id)}
        activeKey={activeKey}
        isMobile={isMobile()}
      />
    );
  }

  projectsView = () => {
    if (!this.props.user) {
      this.props.redirectToLogin();
    } else {
      return (
        <div>
          <Projects
            user={this.props.user}
            onPressProject={() =>
              this.props.redirectToAgenda(this.props.activeProject.id)
            }
            handleLogout={this.handleLogout}
          />
        </div>
      );
    }
  };

  agendaScreen = () => {
    return (
      <div>
        <Agenda
          renderProjectNav={() => this.renderProjectNav(1)}
          user={this.props.user}
          onProjectDelete={() => this.onProjectDelete()}
          onRequestShowTaskList={() =>
            this.props.redirectToTaskList(this.props.activeProject.id)
          }
          onRequestShowTimeline={() =>
            this.props.redirectToTimeLine(this.props.activeProject.id)
          }
        />
      </div>
    );
  };

  timelineScreen = () => {
    return (
      <div>
        <TimelineView
          renderProjectNav={() => this.renderProjectNav(2)}
          user={this.props.user}
        />
      </div>
    );
  };

  taskListScreen = () => {
    return (
      <div>
        <TaskListView
          renderProjectNav={() => this.renderProjectNav(3)}
          user={this.props.user}
        />
      </div>
    );
  };

  profileScreen = () => {
    return <Profile user={this.props.user}></Profile>;
  };

  subscriptionScreen = () => {
    return <Subscription user={this.props.user}></Subscription>;
  };
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    activeProject: getActiveProject(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setActiveProject: () => dispatch(setActiveProject()),
    addInvitedProjects: () => dispatch(addInvitedProjects()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserView);



// WEBPACK FOOTER //
// ./src/views/user/User.js